export default {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    materialUploadingList: [],
  },
  mutations: {
    setMaterialUploadingList(state, materialUploadingList) {
      state.materialUploadingList = materialUploadingList;
    },
  },
  getters: {
    getMaterialUploadingList: (state) => {
      return state.materialUploadingList;
    },
  },
};
